export function financial(n: string | number | undefined) {
  const number = Number.parseInt(n as string, 10);

  if (isNaN(number)) return 0;

  return number / 100;
}
